var defaults = {
  template: 'fiftyFifty'
};
var primaryColumnWidth = {
  fiftyFifty: '50%',
  sixtyForty: '58%',
  seventyThirty: '68%'
};
var secondaryColumnWidth = {
  fiftyFifty: '50%',
  sixtyForty: '42%',
  seventyThirty: '32%'
};

export { defaults, primaryColumnWidth, secondaryColumnWidth };
//# sourceMappingURL=config.esm.js.map
